namespace GeniuzPOS.PosShift {
    export interface PsVatRefundPrintingParaRow {
        Id?: number;
        FromCode?: string;
        P1Height?: number;
        P1Width?: number;
        P1PaddingTop?: number;
        P1PaddingLeft?: number;
        P1HeaderHeight?: number;
        P1HeaderLeftWidth?: number;
        P1HeaderRightWidth?: number;
        P1HeaderRightPaddingTop?: number;
        P1HeaderLeftShopTaxIdPaddingLeft?: number;
        P1HeaderLeftShopTaxIdPaddingRight?: number;
        P1HeaderLeftShopTaxIdHeight?: number;
        P1HeaderLeftShopTaxIdFontSize?: number;
        P1HeaderLeftShopTaxIdSpacing?: number;
        P1HeaderLeftBranchPaddingLeft?: number;
        P1HeaderLeftBranchPaddingRight?: number;
        P1HeaderLeftBranchHeight?: number;
        P1HeaderLeftBranchFontSize?: number;
        P1HeaderLeftBranchSpacing?: number;
        P1HeaderLeftCompanyNamePaddingLeft?: number;
        P1HeaderLeftCompanyNameFontSize?: number;
        P1HeaderLeftAddNoPaddingLeft?: number;
        P1HeaderLeftAddNoHeight?: number;
        P1HeaderLeftAddNoWidth?: number;
        P1HeaderLeftAddNoFontSize?: number;
        P1HeaderLeftStreetPaddingLeft?: number;
        P1HeaderLeftStreetFontSize?: number;
        P1HeaderLeftDistrictPaddingLeft?: number;
        P1HeaderLeftDistrictHeight?: number;
        P1HeaderLeftDistrictWidth?: number;
        P1HeaderLeftDistrictFontSize?: number;
        P1HeaderLeftProvicePaddingLeft?: number;
        P1HeaderLeftProviceFontSize?: number;
        P1HeaderLeftTelnoPaddingLeft?: number;
        P1HeaderLeftTelnoHeight?: number;
        P1HeaderLeftTelnoFontSize?: number;
        P1HeaderRightTNamePaddingLeft?: number;
        P1HeaderRightTNameHeight?: number;
        P1HeaderRightTNameFontSize?: number;
        P1HeaderRightNationPaddingLeft?: number;
        P1HeaderRightNationHeight?: number;
        P1HeaderRightNationFontSize?: number;
        P1HeaderRightPassnoPaddingLeft?: number;
        P1HeaderRightPassnoHeight?: number;
        P1HeaderRightPassnoFontSize?: number;
        P1HeaderRightDatePaddingTop?: number;
        P1HeaderRightDateHeight?: number;
        P1HeaderRightDateFontSize?: number;
        P1HeaderRightDateLeftPaddingLeft?: number;
        P1HeaderRightDateLeftWidth?: number;
        P1HeaderRightDateLeftMmyyWidth?: number;
        P1HeaderRightDateRightPaddingLeft?: number;
        P1HeaderRightDateRightWidth?: number;
        P1HeaderRightDateRightMmyyWidth?: number;
        P1DetailLeftWidth?: number;
        P1DetailLeftHeight?: number;
        P1DetailLeftTablePaddingTop?: number;
        P1DetailLeftTablePaddingLeft?: number;
        P1DetailLeftTableRowHeight?: number;
        P1DetailLeftTableC1Width?: number;
        P1DetailLeftTableC2Width?: number;
        P1DetailLeftTableC3Width?: number;
        P1DetailLeftTableC4Width?: number;
        P1DetailLeftTableC5Width?: number;
        P1DetailLeftTableC5PeddingRight?: number;
        P1DetailRightWidth?: number;
        P1DetailRightPaddingTop?: number;
        P1DetailAddressPHeight?: number;
        P1DetailAddressPaddingLeft?: number;
        P1DetailAddressPaddingTop?: number;
        P1DetailAddressFontSize?: number;
        P1DetailLine2PHeight?: number;
        P1DetailLine2PaddingTop?: number;
        P1DetailLine2FontSize?: number;
        P1DetailLine2PostcodePaddingWidth?: number;
        P1DetailLine2PostcodePaddingLeft?: number;
        P1DetailLine2CityPaddingWidth?: number;
        P1DetailLine2CityPaddingLeft?: number;
        P1DetailLine2CountyPaddingLeft?: number;
        P1DetailEmailPHeight?: number;
        P1DetailEmailPaddingLeft?: number;
        P1DetailEmailPaddingTop?: number;
        P1DetailEmailFontSize?: number;
        P1DetailPhonenumberPHeight?: number;
        P1DetailPhonenumberPaddingLeft?: number;
        P1DetailPhonenumberPaddingTop?: number;
        P1DetailPhonenumberFontSize?: number;
        P1FooterLeftWidth?: number;
        P1FooterLeftHeight?: number;
        P1FooterPagetoWidth?: number;
        P1FooterPagetoHeight?: number;
        P1FooterPagetoPaddingButtom?: number;
        P1FooterPagetoPaddingLeft?: number;
        P1FooterPagetoFontSize?: number;
        P1FooterSumWidth?: number;
        P1FooterSumPeddingRight?: number;
        P1FooterSumFontSize?: number;
        P1FooterPageNext?: number;
        P2StartHeight?: number;
        P2Height?: number;
        P2Width?: number;
        P2PaddingTop?: number;
        P2PaddingLeft?: number;
        P2PaddingRight?: number;
        P2PageHeight?: number;
        P2PageLeft?: number;
        P2PageNowFontSize?: number;
        P2PageNoHeight?: number;
        P2PageNowPaddingLeft?: number;
        P2PageNowWidth?: number;
        P2PageAllPaddingLeft?: number;
        P2HeaderBookNoHeight?: number;
        P2HeaderBookNoPaddingButtom?: number;
        P2HeaderBookNoPaddingLeft?: number;
        P2HeaderBookNoWidth?: number;
        P2HeaderNoPaddingLeft?: number;
        P2HeaderTaxBranchHeight?: number;
        P2HeaderTaxBranchFontSize?: number;
        P2HeaderTaxHeight?: number;
        P2HeaderTaxPaddingLeft?: number;
        P2HeaderTaxPaddingRigth?: number;
        P2HeaderTaxSpacing?: number;
        P2HeaderBranchHeight?: number;
        P2HeaderBranchPaddingLeft?: number;
        P2HeaderBranchPaddingRigth?: number;
        P2HeaderBranchSpacing?: number;
        P2HeaderSaleHeight?: number;
        P2HeaderSalePaddingButtom?: number;
        P2HeaderSalePaddingLeft?: number;
        P2HeaderSaleFontSize?: number;
        P2DetailWidth?: number;
        P2DetailHeight?: number;
        P2DetailPaddingTop?: number;
        P2DetailPaddingLeft?: number;
        P2DetailPaddingRight?: number;
        P2DetailRowHeight?: number;
        P2DetailC1Width?: number;
        P2DetailC2Width?: number;
        P2DetailC2PaddingLeft?: number;
        P2DetailC3Width?: number;
        P2DetailC3PaddingLeft?: number;
        P2DetailC4Width?: number;
        P2DetailC4PaddingLeft?: number;
        P2DetailC5Width?: number;
        P2DetailC5PaddingRight?: number;
        P2FooterWidth?: number;
        P2FooterHeight?: number;
        P2FooterLeft?: number;
        P2FooterSumPaddingRight?: number;
        P2FooterPageNext?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsVatRefundPrintingParaRow {
        export const idProperty = 'FromCode';
        export const nameProperty = 'FromCode';
        export const localTextPrefix = 'PosShift.PsVatRefundPrintingPara';
        export const lookupKey = 'PosShift.PsVatRefundPrintingPara';

        export function getLookup(): Q.Lookup<PsVatRefundPrintingParaRow> {
            return Q.getLookup<PsVatRefundPrintingParaRow>('PosShift.PsVatRefundPrintingPara');
        }
        export const deletePermission = '1POSBASE:ใบกำกับภาษี:ตั้งค่าหน้ากระดาษการพิมพ์:Modify';
        export const insertPermission = '1POSBASE:ใบกำกับภาษี:ตั้งค่าหน้ากระดาษการพิมพ์:Modify';
        export const readPermission = '1POSBASE:ใบกำกับภาษี:ตั้งค่าหน้ากระดาษการพิมพ์:View';
        export const updatePermission = '1POSBASE:ใบกำกับภาษี:ตั้งค่าหน้ากระดาษการพิมพ์:Modify';

        export declare const enum Fields {
            Id = "Id",
            FromCode = "FromCode",
            P1Height = "P1Height",
            P1Width = "P1Width",
            P1PaddingTop = "P1PaddingTop",
            P1PaddingLeft = "P1PaddingLeft",
            P1HeaderHeight = "P1HeaderHeight",
            P1HeaderLeftWidth = "P1HeaderLeftWidth",
            P1HeaderRightWidth = "P1HeaderRightWidth",
            P1HeaderRightPaddingTop = "P1HeaderRightPaddingTop",
            P1HeaderLeftShopTaxIdPaddingLeft = "P1HeaderLeftShopTaxIdPaddingLeft",
            P1HeaderLeftShopTaxIdPaddingRight = "P1HeaderLeftShopTaxIdPaddingRight",
            P1HeaderLeftShopTaxIdHeight = "P1HeaderLeftShopTaxIdHeight",
            P1HeaderLeftShopTaxIdFontSize = "P1HeaderLeftShopTaxIdFontSize",
            P1HeaderLeftShopTaxIdSpacing = "P1HeaderLeftShopTaxIdSpacing",
            P1HeaderLeftBranchPaddingLeft = "P1HeaderLeftBranchPaddingLeft",
            P1HeaderLeftBranchPaddingRight = "P1HeaderLeftBranchPaddingRight",
            P1HeaderLeftBranchHeight = "P1HeaderLeftBranchHeight",
            P1HeaderLeftBranchFontSize = "P1HeaderLeftBranchFontSize",
            P1HeaderLeftBranchSpacing = "P1HeaderLeftBranchSpacing",
            P1HeaderLeftCompanyNamePaddingLeft = "P1HeaderLeftCompanyNamePaddingLeft",
            P1HeaderLeftCompanyNameFontSize = "P1HeaderLeftCompanyNameFontSize",
            P1HeaderLeftAddNoPaddingLeft = "P1HeaderLeftAddNoPaddingLeft",
            P1HeaderLeftAddNoHeight = "P1HeaderLeftAddNoHeight",
            P1HeaderLeftAddNoWidth = "P1HeaderLeftAddNoWidth",
            P1HeaderLeftAddNoFontSize = "P1HeaderLeftAddNoFontSize",
            P1HeaderLeftStreetPaddingLeft = "P1HeaderLeftStreetPaddingLeft",
            P1HeaderLeftStreetFontSize = "P1HeaderLeftStreetFontSize",
            P1HeaderLeftDistrictPaddingLeft = "P1HeaderLeftDistrictPaddingLeft",
            P1HeaderLeftDistrictHeight = "P1HeaderLeftDistrictHeight",
            P1HeaderLeftDistrictWidth = "P1HeaderLeftDistrictWidth",
            P1HeaderLeftDistrictFontSize = "P1HeaderLeftDistrictFontSize",
            P1HeaderLeftProvicePaddingLeft = "P1HeaderLeftProvicePaddingLeft",
            P1HeaderLeftProviceFontSize = "P1HeaderLeftProviceFontSize",
            P1HeaderLeftTelnoPaddingLeft = "P1HeaderLeftTelnoPaddingLeft",
            P1HeaderLeftTelnoHeight = "P1HeaderLeftTelnoHeight",
            P1HeaderLeftTelnoFontSize = "P1HeaderLeftTelnoFontSize",
            P1HeaderRightTNamePaddingLeft = "P1HeaderRightTNamePaddingLeft",
            P1HeaderRightTNameHeight = "P1HeaderRightTNameHeight",
            P1HeaderRightTNameFontSize = "P1HeaderRightTNameFontSize",
            P1HeaderRightNationPaddingLeft = "P1HeaderRightNationPaddingLeft",
            P1HeaderRightNationHeight = "P1HeaderRightNationHeight",
            P1HeaderRightNationFontSize = "P1HeaderRightNationFontSize",
            P1HeaderRightPassnoPaddingLeft = "P1HeaderRightPassnoPaddingLeft",
            P1HeaderRightPassnoHeight = "P1HeaderRightPassnoHeight",
            P1HeaderRightPassnoFontSize = "P1HeaderRightPassnoFontSize",
            P1HeaderRightDatePaddingTop = "P1HeaderRightDatePaddingTop",
            P1HeaderRightDateHeight = "P1HeaderRightDateHeight",
            P1HeaderRightDateFontSize = "P1HeaderRightDateFontSize",
            P1HeaderRightDateLeftPaddingLeft = "P1HeaderRightDateLeftPaddingLeft",
            P1HeaderRightDateLeftWidth = "P1HeaderRightDateLeftWidth",
            P1HeaderRightDateLeftMmyyWidth = "P1HeaderRightDateLeftMmyyWidth",
            P1HeaderRightDateRightPaddingLeft = "P1HeaderRightDateRightPaddingLeft",
            P1HeaderRightDateRightWidth = "P1HeaderRightDateRightWidth",
            P1HeaderRightDateRightMmyyWidth = "P1HeaderRightDateRightMmyyWidth",
            P1DetailLeftWidth = "P1DetailLeftWidth",
            P1DetailLeftHeight = "P1DetailLeftHeight",
            P1DetailLeftTablePaddingTop = "P1DetailLeftTablePaddingTop",
            P1DetailLeftTablePaddingLeft = "P1DetailLeftTablePaddingLeft",
            P1DetailLeftTableRowHeight = "P1DetailLeftTableRowHeight",
            P1DetailLeftTableC1Width = "P1DetailLeftTableC1Width",
            P1DetailLeftTableC2Width = "P1DetailLeftTableC2Width",
            P1DetailLeftTableC3Width = "P1DetailLeftTableC3Width",
            P1DetailLeftTableC4Width = "P1DetailLeftTableC4Width",
            P1DetailLeftTableC5Width = "P1DetailLeftTableC5Width",
            P1DetailLeftTableC5PeddingRight = "P1DetailLeftTableC5PeddingRight",
            P1DetailRightWidth = "P1DetailRightWidth",
            P1DetailRightPaddingTop = "P1DetailRightPaddingTop",
            P1DetailAddressPHeight = "P1DetailAddressPHeight",
            P1DetailAddressPaddingLeft = "P1DetailAddressPaddingLeft",
            P1DetailAddressPaddingTop = "P1DetailAddressPaddingTop",
            P1DetailAddressFontSize = "P1DetailAddressFontSize",
            P1DetailLine2PHeight = "P1DetailLine2PHeight",
            P1DetailLine2PaddingTop = "P1DetailLine2PaddingTop",
            P1DetailLine2FontSize = "P1DetailLine2FontSize",
            P1DetailLine2PostcodePaddingWidth = "P1DetailLine2PostcodePaddingWidth",
            P1DetailLine2PostcodePaddingLeft = "P1DetailLine2PostcodePaddingLeft",
            P1DetailLine2CityPaddingWidth = "P1DetailLine2CityPaddingWidth",
            P1DetailLine2CityPaddingLeft = "P1DetailLine2CityPaddingLeft",
            P1DetailLine2CountyPaddingLeft = "P1DetailLine2CountyPaddingLeft",
            P1DetailEmailPHeight = "P1DetailEmailPHeight",
            P1DetailEmailPaddingLeft = "P1DetailEmailPaddingLeft",
            P1DetailEmailPaddingTop = "P1DetailEmailPaddingTop",
            P1DetailEmailFontSize = "P1DetailEmailFontSize",
            P1DetailPhonenumberPHeight = "P1DetailPhonenumberPHeight",
            P1DetailPhonenumberPaddingLeft = "P1DetailPhonenumberPaddingLeft",
            P1DetailPhonenumberPaddingTop = "P1DetailPhonenumberPaddingTop",
            P1DetailPhonenumberFontSize = "P1DetailPhonenumberFontSize",
            P1FooterLeftWidth = "P1FooterLeftWidth",
            P1FooterLeftHeight = "P1FooterLeftHeight",
            P1FooterPagetoWidth = "P1FooterPagetoWidth",
            P1FooterPagetoHeight = "P1FooterPagetoHeight",
            P1FooterPagetoPaddingButtom = "P1FooterPagetoPaddingButtom",
            P1FooterPagetoPaddingLeft = "P1FooterPagetoPaddingLeft",
            P1FooterPagetoFontSize = "P1FooterPagetoFontSize",
            P1FooterSumWidth = "P1FooterSumWidth",
            P1FooterSumPeddingRight = "P1FooterSumPeddingRight",
            P1FooterSumFontSize = "P1FooterSumFontSize",
            P1FooterPageNext = "P1FooterPageNext",
            P2StartHeight = "P2StartHeight",
            P2Height = "P2Height",
            P2Width = "P2Width",
            P2PaddingTop = "P2PaddingTop",
            P2PaddingLeft = "P2PaddingLeft",
            P2PaddingRight = "P2PaddingRight",
            P2PageHeight = "P2PageHeight",
            P2PageLeft = "P2PageLeft",
            P2PageNowFontSize = "P2PageNowFontSize",
            P2PageNoHeight = "P2PageNoHeight",
            P2PageNowPaddingLeft = "P2PageNowPaddingLeft",
            P2PageNowWidth = "P2PageNowWidth",
            P2PageAllPaddingLeft = "P2PageAllPaddingLeft",
            P2HeaderBookNoHeight = "P2HeaderBookNoHeight",
            P2HeaderBookNoPaddingButtom = "P2HeaderBookNoPaddingButtom",
            P2HeaderBookNoPaddingLeft = "P2HeaderBookNoPaddingLeft",
            P2HeaderBookNoWidth = "P2HeaderBookNoWidth",
            P2HeaderNoPaddingLeft = "P2HeaderNoPaddingLeft",
            P2HeaderTaxBranchHeight = "P2HeaderTaxBranchHeight",
            P2HeaderTaxBranchFontSize = "P2HeaderTaxBranchFontSize",
            P2HeaderTaxHeight = "P2HeaderTaxHeight",
            P2HeaderTaxPaddingLeft = "P2HeaderTaxPaddingLeft",
            P2HeaderTaxPaddingRigth = "P2HeaderTaxPaddingRigth",
            P2HeaderTaxSpacing = "P2HeaderTaxSpacing",
            P2HeaderBranchHeight = "P2HeaderBranchHeight",
            P2HeaderBranchPaddingLeft = "P2HeaderBranchPaddingLeft",
            P2HeaderBranchPaddingRigth = "P2HeaderBranchPaddingRigth",
            P2HeaderBranchSpacing = "P2HeaderBranchSpacing",
            P2HeaderSaleHeight = "P2HeaderSaleHeight",
            P2HeaderSalePaddingButtom = "P2HeaderSalePaddingButtom",
            P2HeaderSalePaddingLeft = "P2HeaderSalePaddingLeft",
            P2HeaderSaleFontSize = "P2HeaderSaleFontSize",
            P2DetailWidth = "P2DetailWidth",
            P2DetailHeight = "P2DetailHeight",
            P2DetailPaddingTop = "P2DetailPaddingTop",
            P2DetailPaddingLeft = "P2DetailPaddingLeft",
            P2DetailPaddingRight = "P2DetailPaddingRight",
            P2DetailRowHeight = "P2DetailRowHeight",
            P2DetailC1Width = "P2DetailC1Width",
            P2DetailC2Width = "P2DetailC2Width",
            P2DetailC2PaddingLeft = "P2DetailC2PaddingLeft",
            P2DetailC3Width = "P2DetailC3Width",
            P2DetailC3PaddingLeft = "P2DetailC3PaddingLeft",
            P2DetailC4Width = "P2DetailC4Width",
            P2DetailC4PaddingLeft = "P2DetailC4PaddingLeft",
            P2DetailC5Width = "P2DetailC5Width",
            P2DetailC5PaddingRight = "P2DetailC5PaddingRight",
            P2FooterWidth = "P2FooterWidth",
            P2FooterHeight = "P2FooterHeight",
            P2FooterLeft = "P2FooterLeft",
            P2FooterSumPaddingRight = "P2FooterSumPaddingRight",
            P2FooterPageNext = "P2FooterPageNext",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
